import { ClinicalSpecialistIcon } from '@icons';
import { CCResourceType } from '@/api/apis/resources/schedule';

type CCUserCellSubtitleProps = {
  resourceType: CCResourceType;
};

export const CCUserCellSubtitle = ({ resourceType }: CCUserCellSubtitleProps) => {
  return (
    <div className="flex gap-0.5 items-center">
      <ClinicalSpecialistIcon className="text-base-30 size-3" />
      <span className="text-base-25 text-s-m">{resourceType}</span>
    </div>
  );
};
